<template>
  <v-row>
    <v-col md="3" sm="6" cols="12" v-for="(item, i) in serviceContent" :key="i">
      <v-card shaped elevation="12" class="service-custom-wrapper">
        <v-img :src="item.src" max-height="150px"></v-img>
        <v-card-title>{{ item.title }}</v-card-title>
        <v-card-text class="text-left" v-html="item.desc"> </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn :to="item.url" color="orange accent-2" text>
            read more...
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      serviceContent: [
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_012.jpg"),
          title: "Landlords & Estate Agents",
          desc: `We work with Landlords, developers and estate agents to provide solutions to their requirements.`,
          url: "/landlord",
        },
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_015.jpg"),
          title: "Investors",
          desc: `Do you want higher returns on your investment?`,
          url: "/investors",
        },
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_006.jpg"),
          title: "Corporate Housing",
          desc: `Quality affordable accommodation for your team?`,
          url: "/corporate-housing",
        },
        {
          src: require("../assets/images/stockpics/zoe_estates_bg_room_002.jpg"),
          title: "Room Let Housing (HMO)",
          desc: `Are you looking for  room let accommodation with all-inclusive bills`,
          url: "/room-let-housing",
        },
      ],
    };
  },
  methods: {
    iconSvg(icon) {
      return feather.icons[icon].toSvg();
    },
  },
};
</script>
<style scoped>
.v-card__title {
  word-break: break-word !important;
}
</style>
